import $ from 'jquery';

export class MenuButton {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el));
  }

  public $elem: JQuery;

  constructor(public $block: JQuery) {
    this.$elem = $block.find('.responsive-menu-trigger');
    this.$elem.click((e) => {
      this.$elem.toggleClass('active');
      $('.responsive-menu').toggleClass('show');
      this.calcHeight($('.responsive-menu'));
    });
  }

  public calcHeight($el) {
    if ($el.hasClass('show')) {
      const currentPos = $el[0].getBoundingClientRect().top;
      const winHeight = $(window).height();
      $el.css('maxHeight', winHeight - currentPos);
    } else {
      $el.removeAttr('style');
    }
  }
}
